<template>
  <li
    :class="{unavailable: !available, available, new: isNew, 'large': !shortTheme, [$currentTheme]: true}"
  >
    <component
      :is="available ? 'router-link':'div'"
      class="card-content"
      :to="available ?`/${product.collection}/${product.shortId}`:'#'"
      @click="onClick"
    >
      <div class="arrow">
        <TopRightArrow v-if="available" />
        <CalendarIcon v-else />
      </div>
      <CountdownBadge
        v-if="product.subscription && isSubscriptionPeriod() && isNew && $store.state.attributes.enable_countdowns === true"
        class="countdown"
        :product="product"
      />
      <div class="pictures">
        <div
          v-if="!shortTheme"
          class="picture back"
          :class="`collections-${product.collection}-product-${product.metal}`"
        />
        <div
          class="picture"
          :class="`common-product-${product.shortId}`"
        >
          <NewProductBadge
            v-if="isNew"
            class="new"
          />
        </div>
      </div>
      <p
        class="product-infos"
        v-html="product.label"
      />
      <p class="reminder-infos">
        <span>{{ getSuscriptionMonthPeriod(product) }}</span>
        <span>{{ $config.common.reminder.cta }}</span>
      </p>
    </component>
    <fade-transition>
      <calendar-panel
        v-if="!available && showReminder"
        :product="product"
        class="calendar-panel"
        @close="showReminder = false"
      />
    </fade-transition>
  </li>
</template>
<script>
import NewProductBadge from '@/components/common/badges/NewProductBadge.vue';
import TopRightArrow from '@/components/common/icons/TopRightArrow.vue';
import CountdownBadge from '@/components/common/badges/CountdownBadge.vue';
import CalendarIcon from '@/components/common/icons/CalendarIcon.vue';
import CalendarPanel from '@/components/common/CalendarPanel.vue';
import TimerMixin from '@/mixins/TimerMixin.vue';

export default {
  name: 'ProductListCard',
  components: {
    NewProductBadge,
    TopRightArrow,
    CountdownBadge,
    CalendarIcon,
    CalendarPanel,
  },
  mixins: [TimerMixin],
  props: {
    product: {
      type: Object,
      required: true,
    },
    shortTheme: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      showReminder: false,
    };
  },
  computed: {
    available() {
      return this.product.wave <= this.$currentWave;
    },
    isNew() {
      return (this.product.wave === this.$currentWave) && this.$currentWave > 1;
    },
  },
  methods: {
    onClick() {
      if (!this.available && (this.product.subscription?.startDate || this.product.launchDate)) {
        this.showReminder = true;//! this.showReminder;
      }
    },
  },
};
</script>
<style lang="stylus" scoped>
li {
  --fontColor: var(--inverted-text-color);
  --bgColor: var(--main-color);
  --borderColor: var(--main-color);
  --iconColor: var(--inverted-text-color);
  list-style: none;
  border: 1px solid var(--borderColor);
  border-radius: 10px;
  width: 100%;
  transition: background-color 0.3s ease;
  position: relative

  &.large { // when card is in large mode with 2 pictures, on dark background (product page)
    --fontColor: var(--text-color);
    --bgColor: var(--main-color);
    --borderColor: var(--text-color);
    --iconColor: var(--main-color);

    &.large.equality {
      --iconColor: var(--text-color);
    }

    &.unavailable {
      --borderColor: var(--text-color);
    }

    &:hover {
      .picture.back {
        transform: translateY(+50%) scale(0.8);
      }
      .picture:not(.back) {
        transform: translateY(-50px) scale(1.3);
        .new {
          opacity: 0;
          transform: scale(0.8);
        }
      }
    }
  }

  &.unavailable {
    --borderColor: var(--light-color);

    .pictures {
      opacity: 0.2;
      transition: opacity 0.3s ease;
    }
  }

  &:hover {
    background-color: var(--bgColor);
    --fontColor: var(--text-color);

    .card-content .arrow {
      transform: translateX(0);
      opacity: 1;
    }

    .pictures {
        opacity: 1;
      .picture {
        transform: scale(1.08);
      }
    }
  }

  &.unavailable {
    // pointer-events: none;
    &:hover {
      .product-infos {
        display: none;
      }
      .reminder-infos {
        display: flex;
      }
    }
  }


  .card-content {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
    gap: 10px;
    padding: 15px 20px;
    cursor: pointer;

    .arrow {
      position: absolute;
      top: 10px;
      right: 10px;
      color: var(--iconColor);
      border: 1px solid var(--borderColor);
      border-radius: 50%;
      background-color: var(--white-color);
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;
      transform: translateX(-10px);
      opacity: 0;
      transition: all 0.3s ease;
    }

    .countdown {
      position: absolute;
      top: 95px
      left: 22px;
      transform: translate(-50%, -50%);
      z-index: 10;
    }

    .pictures {
      display: flex;
      flex-direction: column;
      .picture {
        position: relative;
        transition: all 0.3s ease;
        &:not(.back) .new {
          position: absolute;
          top: 52%;
          left: 65%;
          color: var(--fontColor);
          transition: all 0.2s ease;
        }

        &.back {
          margin-bottom: -50px;
        }
      }
    }

    div {
        align-self: center;
    }

    p.product-infos, p.reminder-infos {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      color: var(--fontColor);
      font-size: 14px;
      margin-bottom: 0;
      font-weight: 400;

      span:last-child {
        font-weight: bold;
      }
    }

    p.reminder-infos {
      display: none;
    }
  }

  .calendar-panel {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 20;
  }
}
</style>
